import { render } from "./DashboardModal.vue?vue&type=template&id=fa20d876"
import script from "./DashboardModal.vue?vue&type=script&lang=js"
export * from "./DashboardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__